import { supabase } from './supabase';

/** Add 1 to today's landing-page hit count. */
export const recordHomeHit = async (): Promise<void> => {
  const { error } = await supabase.rpc('increment_page_hit');
  if (error) console.warn('page hit not recorded:', error.message);
};
